import { Buffer } from 'buffer';

export function encode(object) {
  return Buffer.from(JSON.stringify(object)).toString('base64');
}

export function decode(base64String) {
  return JSON.parse(Buffer.from(base64String, 'base64').toString());
}
